import { normalizeFontFamilyName } from './googleFonts'

export const MAX_BG_PANELS = 4
export const MIN_BG_PANELS = 1

export const DEFAULT_BG_FRAME = { scale: 100, x: 50, y: 50 }

export const DEFAULT_SPLIT_STYLE = {
  font_family: 'Fraunces',
  font_size_desktop: 1.75,
  font_size_mobile: 1.25,
  desktop: {
    x: 50,
    y: 42,
    scale: 100,
    rotate: 0,
    height: 100,
    meta_x: 50,
    meta_y: 68,
    meta_width: 42,
    meta_rotate: 0,
    price_x: 50,
    price_y: 74,
    cta_x: 50,
    cta_y: 82,
    /** Área de influência do botão (% do canvas). */
    cta_w: 22,
    cta_h: 9,
  },
  mobile: {
    x: 50,
    y: 38,
    scale: 85,
    rotate: 0,
    height: 100,
    meta_x: 50,
    meta_y: 62,
    meta_width: 72,
    meta_rotate: 0,
    price_x: 50,
    price_y: 70,
    cta_x: 50,
    cta_y: 78,
    cta_w: 42,
    cta_h: 10,
  },
  text_blocks: [],
  /** Altura do hero na loja (mobile), em dvh. Controla o recorte das imagens de base. */
  viewport_height_mobile: 72,
  /** Enquadramento Canva por painel (array paralelo a bg_panels). */
  bg: {
    desktop: [{ ...DEFAULT_BG_FRAME }, { ...DEFAULT_BG_FRAME }],
    mobile: [{ ...DEFAULT_BG_FRAME }, { ...DEFAULT_BG_FRAME }],
  },
  show_product_name: true,
  show_product_price: true,
  show_product_image: true,
  show_cta: true,
  /** 'solid' = botão visível; 'transparent' = hotspot (tracejado só no ERP). */
  cta_appearance: 'solid',
  price_font_family: 'Montserrat',
  price_font_size_desktop: 1.25,
  price_font_size_mobile: 1,
  price_color: '#ecfdf5',
  cta_font_family: 'Montserrat',
  cta_font_size_desktop: 0.9,
  cta_font_size_mobile: 0.8125,
  cta_color: '#37971c',
  cta_bg_color: '#ffffff',
  /** Border-radius do botão em rem (0–3). */
  cta_radius: 2,
}

/** Dimensões do palco WYSIWYG (px) ≈ hero real da loja. */
export const SPLIT_PREVIEW_STAGE = {
  desktop: { width: 1440, height: 810 },
  /** Mobile base @ 72dvh ≈ 520px; o compositor escala conforme viewport_height_mobile */
  mobile: { width: 390, height: 520 },
}

/** Altura do palco mobile em px a partir da config (dvh). */
export function mobilePreviewStageHeight(viewportHeightMobile = 72) {
  const vh = Number(viewportHeightMobile)
  const safe = Number.isFinite(vh) ? Math.min(95, Math.max(45, vh)) : 72
  return Math.round(SPLIT_PREVIEW_STAGE.mobile.height * (safe / 72))
}

const MAX_TEXT_BLOCKS = 6

export function newTextBlockId() {
  return `tb-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`
}

export function newBgPanelId() {
  return `bp-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`
}

/** Estilo inicial de banner novo: overlays desligados. */
export function createBlankSplitStyle(panelCount = 2) {
  return normalizeSplitStyle(
    {
      ...DEFAULT_SPLIT_STYLE,
      show_product_name: false,
      show_product_price: false,
      show_product_image: false,
      show_cta: false,
      text_blocks: [],
    },
    panelCount
  )
}

export function createBgPanel(partial = {}) {
  return {
    id: newBgPanelId(),
    media_type: 'image', // 'image' | 'video'
    image_url: '',
    image_url_mobile: null,
    ...partial,
  }
}

export function isVideoMediaType(raw) {
  return String(raw || '').toLowerCase() === 'video'
}

export function panelLooksLikeVideo(url) {
  const s = String(url || '').toLowerCase()
  if (!s) return false
  return (
    s.includes('/video/upload/') ||
    /\.(mp4|webm|mov|m4v)(\?|#|$)/i.test(s)
  )
}

export function isVideoPanel(panel, previewMode = 'desktop') {
  if (!panel) return false
  // Só a URL do breakpoint atual (desktop pode ser foto e mobile vídeo)
  const desktop = typeof panel.image_url === 'string' ? panel.image_url : ''
  let url = desktop
  if (previewMode === 'mobile') {
    if (panel.image_url_mobile === '__none__') url = ''
    else if (panel.image_url_mobile) url = panel.image_url_mobile
    else url = desktop
  }
  return panelLooksLikeVideo(url)
}

export function createTextBlock(partial = {}) {
  return normalizeTextBlock({
    id: newTextBlockId(),
    text: 'Novo texto',
    font_family: 'Montserrat',
    font_size_desktop: 1.25,
    font_size_mobile: 1,
    color: '#ffffff',
    desktop: { x: 50, y: 22, width: 42, rotate: 0 },
    mobile: { x: 50, y: 18, width: 72, rotate: 0 },
    ...partial,
  })
}

function clamp(v, min, max, fb) {
  const n = Number(v)
  if (!Number.isFinite(n)) return fb
  return Math.min(max, Math.max(min, n))
}

function normalizeHexColor(raw, fallback) {
  const s = typeof raw === 'string' ? raw.trim() : ''
  if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(s)) return s
  return fallback
}

function placeTextBox(p, fb) {
  const o = p && typeof p === 'object' ? p : {}
  return {
    x: clamp(o.x, 5, 95, fb.x),
    y: clamp(o.y, 5, 95, fb.y),
    width: clamp(o.width, 12, 92, fb.width),
    rotate: clamp(o.rotate, -180, 180, fb.rotate),
  }
}

function placeProduct(p, fb) {
  const o = p && typeof p === 'object' ? p : {}
  return {
    x: clamp(o.x, 5, 95, fb.x),
    y: clamp(o.y, 5, 95, fb.y),
    scale: clamp(o.scale, 40, 180, fb.scale),
    rotate: clamp(o.rotate, -180, 180, fb.rotate ?? 0),
    height: clamp(o.height, 40, 220, fb.height ?? 100),
    meta_x: clamp(o.meta_x, 5, 95, fb.meta_x),
    meta_y: clamp(o.meta_y, 5, 95, fb.meta_y),
    meta_width: clamp(o.meta_width, 12, 92, fb.meta_width),
    meta_rotate: clamp(o.meta_rotate, -180, 180, fb.meta_rotate),
    price_x: clamp(o.price_x, 5, 95, fb.price_x),
    price_y: clamp(o.price_y, 5, 95, fb.price_y),
    cta_x: clamp(o.cta_x, 5, 95, fb.cta_x),
    cta_y: clamp(o.cta_y, 5, 95, fb.cta_y),
    cta_w: clamp(o.cta_w, 8, 90, fb.cta_w ?? 22),
    cta_h: clamp(o.cta_h, 4, 60, fb.cta_h ?? 9),
  }
}

export function normalizeTextBlock(raw, index = 0) {
  const src = raw && typeof raw === 'object' ? raw : {}
  const id =
    typeof src.id === 'string' && src.id.trim()
      ? src.id.trim().slice(0, 64)
      : `tb-${index + 1}`
  // Não usar trim(): a normalização roda a cada tecla e apagaria espaços
  // entre palavras enquanto o usuário digita.
  const text =
    typeof src.text === 'string' ? src.text.slice(0, 200) : 'Texto'
  return {
    id,
    text: text.length > 0 ? text : 'Texto',
    font_family: normalizeFontFamilyName(src.font_family || 'Montserrat'),
    font_size_desktop: clamp(src.font_size_desktop, 0.6, 4, 1.25),
    font_size_mobile: clamp(src.font_size_mobile, 0.6, 3, 1),
    color: normalizeHexColor(src.color, '#ffffff'),
    desktop: placeTextBox(src.desktop, { x: 50, y: 22, width: 42, rotate: 0 }),
    mobile: placeTextBox(src.mobile, { x: 50, y: 18, width: 72, rotate: 0 }),
    show_desktop: src.show_desktop !== false,
    show_mobile: src.show_mobile !== false,
  }
}

export function placeBgFrame(p, fb = DEFAULT_BG_FRAME) {
  const o = p && typeof p === 'object' ? p : {}
  return {
    scale: clamp(o.scale, 100, 280, fb.scale),
    x: clamp(o.x, 0, 100, fb.x),
    y: clamp(o.y, 0, 100, fb.y),
  }
}

function framesFromLegacySide(raw) {
  const src = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {}
  if (Array.isArray(raw)) return null
  if (src.left || src.right) {
    return [
      placeBgFrame(src.left, DEFAULT_BG_FRAME),
      placeBgFrame(src.right, DEFAULT_BG_FRAME),
    ]
  }
  return null
}

/** Normaliza frames de um breakpoint para `count` painéis. */
export function normalizeBgFrames(raw, count = 2) {
  const n = Math.min(MAX_BG_PANELS, Math.max(MIN_BG_PANELS, Number(count) || 2))
  let list = []
  if (Array.isArray(raw)) {
    list = raw.map((f) => placeBgFrame(f, DEFAULT_BG_FRAME))
  } else {
    const legacy = framesFromLegacySide(raw)
    list = legacy || [{ ...DEFAULT_BG_FRAME }, { ...DEFAULT_BG_FRAME }]
  }
  while (list.length < n) list.push({ ...DEFAULT_BG_FRAME })
  return list.slice(0, n)
}

export function normalizeBgStyle(raw, panelCount = 2) {
  const src = raw && typeof raw === 'object' ? raw : {}
  const n = Math.min(
    MAX_BG_PANELS,
    Math.max(MIN_BG_PANELS, Number(panelCount) || 2)
  )
  return {
    desktop: normalizeBgFrames(src.desktop, n),
    mobile: normalizeBgFrames(src.mobile, n),
  }
}

/** Migra left/right legado → bg_panels (1–4). */
export function normalizeBgPanels(rawPanels, legacyBanner = {}) {
  if (Array.isArray(rawPanels) && rawPanels.length > 0) {
    return rawPanels.slice(0, MAX_BG_PANELS).map((p, i) => {
      const src = p && typeof p === 'object' ? p : {}
      const id =
        typeof src.id === 'string' && src.id.trim()
          ? src.id.trim().slice(0, 64)
          : `bp-${i + 1}`
      const image_url =
        typeof src.image_url === 'string' ? src.image_url.trim() : ''
      let image_url_mobile = null
      if (src.image_url_mobile === '__none__') image_url_mobile = '__none__'
      else if (
        typeof src.image_url_mobile === 'string' &&
        src.image_url_mobile.trim()
      ) {
        image_url_mobile = src.image_url_mobile.trim()
      }
      // media_type segue a mídia DESKTOP (mobile pode ser outro tipo)
      return {
        id,
        media_type: panelLooksLikeVideo(image_url) ? 'video' : 'image',
        image_url,
        image_url_mobile,
      }
    })
  }

  const left = legacyBanner.image_url_left || ''
  const right = legacyBanner.image_url_right || ''
  const leftM = legacyBanner.image_url_left_mobile
  const rightM = legacyBanner.image_url_right_mobile
  const classic =
    legacyBanner.image_url ||
    legacyBanner.image_url_mobile ||
    legacyBanner.image_url_desktop ||
    ''

  const panels = []
  if (left || (!right && classic)) {
    panels.push(
      createBgPanel({
        image_url: left || classic,
        image_url_mobile: leftM ?? null,
      })
    )
  }
  if (right) {
    panels.push(
      createBgPanel({
        image_url: right,
        image_url_mobile: rightM ?? null,
      })
    )
  }
  if (panels.length === 0) {
    panels.push(createBgPanel(), createBgPanel())
  }
  return panels.slice(0, MAX_BG_PANELS)
}

/** Resolve URL efetiva do painel no breakpoint. */
export function resolvePanelUrl(panel, previewMode = 'desktop') {
  if (!panel) return ''
  const desktop = panel.image_url || ''
  if (previewMode !== 'mobile') return desktop
  if (panel.image_url_mobile === '__none__') return ''
  if (panel.image_url_mobile) return panel.image_url_mobile
  return desktop
}

export function bannerHasBgPanels(banner) {
  const panels = normalizeBgPanels(banner?.bg_panels, banner || {})
  return panels.some((p) => {
    const d = p.image_url && p.image_url !== '__none__'
    const m =
      p.image_url_mobile &&
      p.image_url_mobile !== '__none__' &&
      p.image_url_mobile
    return Boolean(d || m)
  })
}

/** Espelha bg_panels → left/right legado (compat API). */
export function panelsToLegacyUrls(panels) {
  const list = Array.isArray(panels) ? panels : []
  const a = list[0] || {}
  const b = list[1] || {}
  return {
    image_url_left: a.image_url || null,
    image_url_right: b.image_url || null,
    image_url_left_mobile: a.image_url_mobile ?? null,
    image_url_right_mobile: b.image_url_mobile ?? null,
    image_url:
      [a.image_url, b.image_url].find((u) => u && u !== '__none__') || null,
  }
}

/** CSS inline para enquadrar a imagem de fundo no viewport do painel. */
export function bgFrameCss(frame) {
  const scale = Math.max(1, (Number(frame?.scale) || 100) / 100)
  const x = Number.isFinite(Number(frame?.x)) ? Number(frame.x) : 50
  const y = Number.isFinite(Number(frame?.y)) ? Number(frame.y) : 50
  const css = {
    objectFit: 'cover',
    objectPosition: `${x}% ${y}%`,
  }
  // Evita transform aninhado com o scale do canvas quando zoom = 100%
  if (scale > 1.001) {
    css.transform = `scale(${scale})`
    css.transformOrigin = `${x}% ${y}%`
  }
  return css
}

export function normalizeSplitStyle(raw, panelCount) {
  const src = raw && typeof raw === 'object' ? raw : {}
  const blocks = Array.isArray(src.text_blocks) ? src.text_blocks : []
  const n =
    panelCount != null
      ? Math.min(MAX_BG_PANELS, Math.max(MIN_BG_PANELS, Number(panelCount) || 2))
      : Array.isArray(src.bg?.desktop)
        ? src.bg.desktop.length
        : Array.isArray(src.bg?.mobile)
          ? src.bg.mobile.length
          : 2
  return {
    font_family: normalizeFontFamilyName(src.font_family),
    font_size_desktop: clamp(
      src.font_size_desktop,
      0.75,
      3.5,
      DEFAULT_SPLIT_STYLE.font_size_desktop
    ),
    font_size_mobile: clamp(
      src.font_size_mobile,
      0.75,
      2.5,
      DEFAULT_SPLIT_STYLE.font_size_mobile
    ),
    desktop: placeProduct(src.desktop, DEFAULT_SPLIT_STYLE.desktop),
    mobile: placeProduct(src.mobile, DEFAULT_SPLIT_STYLE.mobile),
    text_blocks: blocks.slice(0, MAX_TEXT_BLOCKS).map((b, i) => normalizeTextBlock(b, i)),
    viewport_height_mobile: clamp(
      src.viewport_height_mobile,
      45,
      95,
      DEFAULT_SPLIT_STYLE.viewport_height_mobile
    ),
    bg: normalizeBgStyle(src.bg, n),
    // Compat: show_product_meta=false desliga nome e preço
    show_product_name:
      src.show_product_name !== false && src.show_product_meta !== false,
    show_product_price:
      src.show_product_price !== false && src.show_product_meta !== false,
    show_product_image: src.show_product_image !== false,
    show_cta: src.show_cta !== false,
    cta_appearance:
      String(src.cta_appearance || '').toLowerCase() === 'transparent'
        ? 'transparent'
        : 'solid',
    price_font_family: normalizeFontFamilyName(
      src.price_font_family || DEFAULT_SPLIT_STYLE.price_font_family
    ),
    price_font_size_desktop: clamp(
      src.price_font_size_desktop,
      0.6,
      3.5,
      DEFAULT_SPLIT_STYLE.price_font_size_desktop
    ),
    price_font_size_mobile: clamp(
      src.price_font_size_mobile,
      0.6,
      2.5,
      DEFAULT_SPLIT_STYLE.price_font_size_mobile
    ),
    price_color: normalizeHexColor(src.price_color, DEFAULT_SPLIT_STYLE.price_color),
    cta_font_family: normalizeFontFamilyName(
      src.cta_font_family || DEFAULT_SPLIT_STYLE.cta_font_family
    ),
    cta_font_size_desktop: clamp(
      src.cta_font_size_desktop,
      0.55,
      2.5,
      DEFAULT_SPLIT_STYLE.cta_font_size_desktop
    ),
    cta_font_size_mobile: clamp(
      src.cta_font_size_mobile,
      0.55,
      2,
      DEFAULT_SPLIT_STYLE.cta_font_size_mobile
    ),
    cta_color: normalizeHexColor(src.cta_color, DEFAULT_SPLIT_STYLE.cta_color),
    cta_bg_color: normalizeHexColor(
      src.cta_bg_color,
      DEFAULT_SPLIT_STYLE.cta_bg_color
    ),
    cta_radius: clamp(src.cta_radius, 0, 3, DEFAULT_SPLIT_STYLE.cta_radius),
  }
}

export function splitFontCss(family) {
  const f = String(family || '').toLowerCase()
  switch (f) {
    case 'serif':
      return 'Georgia, "Times New Roman", serif'
    case 'sans':
      return '"Segoe UI", system-ui, -apple-system, sans-serif'
    case 'system':
      return 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
    default:
      return `"${String(family).replace(/"/g, '')}", Georgia, serif`
  }
}

export { MAX_TEXT_BLOCKS }
